import {defineViewSlotCreator} from "@verdure/core";

export default defineViewSlotCreator({
})
